import { RouteConfig } from 'vue-router'

const Index = () => import('./index.vue')

export const indexRoute: RouteConfig = {
  path: '/cut-fruit-2025-activity-home',
  name: 'cut_fruit_2025_activity_home',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '切水果',
    ignoreLogin: true,
  },
}

export default [indexRoute]
